import { Injectable, inject } from '@angular/core';
import { NPrivacyState, PrivacyStateService } from '@df/core/meta/privacy-state.service';
import { GtmDlService } from '@df/module-gtm/service/gtm-dl.service';
import './gtm-event-tier-cookie-consent-change';

@Injectable({
    providedIn: 'root'
})
export class GtmEventTierCookieConsentChangeTrigger {
    /**
     * GTM service
     */
    private gtmService = inject(GtmDlService);

    /**
     * DF events service
     */
    private privacyStateService = inject(PrivacyStateService);

    /**
     * Setup event listener
     */
    constructor() {
        this.init();
    }

    /**
     * Setup event listener
     */
    private init() {
        this.privacyStateService.selection$.subscribe(selection => {
            if (selection) {
                this.dispatch(selection);
            }
        });
    }

    /**
     * Dispatch event
     */
    private async dispatch(settings: NPrivacyState.TSelection) {
        return this.gtmService.dispatch({
            event: 'tier_cookie_consent_change',
            settings
        });
    }
}
